import React from "react";

const InstaGram = ({
  wSize = "34",
  hSize = "34",
  bgColor = "#ffffff",
  color = "#666666",
  ...props
}) => {
  return (
    <svg
      width={wSize}
      height={hSize}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 34C7.6126 34 0 26.3874 0 17C0 7.6126 7.6126 0 17 0C26.3874 0 34 7.6126 34 17C34 26.3874 26.3874 34 17 34Z"
        fill="url(#paint0_linear_526_34503)"
      />
      <path
        d="M17.0002 7.48651C20.0976 7.48651 20.4648 7.49671 21.6888 7.55451C22.821 7.60551 23.4364 7.79591 23.8444 7.95571C24.385 8.16651 24.7726 8.41811 25.1772 8.82271C25.5818 9.22731 25.8334 9.61491 26.0442 10.1555C26.204 10.5635 26.391 11.1789 26.4454 12.3111C26.4998 13.5351 26.5134 13.9023 26.5134 16.9997C26.5134 20.0971 26.5032 20.4643 26.4454 21.6883C26.3944 22.8205 26.204 23.4359 26.0442 23.8439C25.8334 24.3845 25.5818 24.7721 25.1772 25.1767C24.7726 25.5813 24.385 25.8329 23.8444 26.0437C23.4364 26.2035 22.821 26.3905 21.6888 26.4449C20.4648 26.4993 20.0976 26.5129 17.0002 26.5129C13.9028 26.5129 13.5356 26.5027 12.3116 26.4449C11.1794 26.3939 10.564 26.2035 10.156 26.0437C9.61538 25.8329 9.22778 25.5813 8.82318 25.1767C8.41858 24.7721 8.16698 24.3845 7.95618 23.8439C7.79638 23.4359 7.60938 22.8205 7.55498 21.6883C7.50058 20.4643 7.48698 20.0971 7.48698 16.9997C7.48698 13.9023 7.49718 13.5351 7.55498 12.3111C7.60598 11.1789 7.79638 10.5635 7.95618 10.1555C8.16698 9.61491 8.41858 9.22731 8.82318 8.82271C9.22778 8.41811 9.61538 8.16651 10.156 7.95571C10.564 7.79591 11.1794 7.60891 12.3116 7.55451C13.5356 7.49671 13.9028 7.48651 17.0002 7.48651ZM17.0002 5.39551C13.8484 5.39551 13.454 5.40911 12.2164 5.46691C10.9822 5.52471 10.139 5.71851 9.39778 6.00751C8.63618 6.29991 7.98678 6.69771 7.34418 7.34371C6.69818 7.98971 6.30378 8.63571 6.00458 9.40071C5.71898 10.1385 5.52178 10.9817 5.46398 12.2193C5.40618 13.4569 5.39258 13.8513 5.39258 17.0031C5.39258 20.1549 5.40618 20.5493 5.46398 21.7869C5.52178 23.0211 5.71558 23.8643 6.00458 24.6055C6.30038 25.3637 6.69818 26.0131 7.34418 26.6557C7.99018 27.3017 8.63618 27.6961 9.40118 27.9953C10.139 28.2809 10.9822 28.4781 12.2198 28.5359C13.4574 28.5937 13.8518 28.6073 17.0036 28.6073C20.1554 28.6073 20.5498 28.5937 21.7874 28.5359C23.0216 28.4781 23.8648 28.2843 24.606 27.9953C25.3642 27.6995 26.0136 27.3017 26.6562 26.6557C27.3022 26.0097 27.6966 25.3637 27.9958 24.5987C28.2814 23.8609 28.4786 23.0177 28.5364 21.7801C28.5942 20.5425 28.6078 20.1481 28.6078 16.9963C28.6078 13.8445 28.5942 13.4501 28.5364 12.2125C28.4786 10.9783 28.2848 10.1351 27.9958 9.39391C27.7 8.63571 27.3022 7.98631 26.6562 7.34371C26.0102 6.69771 25.3642 6.30331 24.5992 6.00411C23.8614 5.71851 23.0182 5.52131 21.7806 5.46351C20.5464 5.40911 20.152 5.39551 17.0002 5.39551Z"
        fill="white"
      />
      <path
        d="M17.0002 11.0391C13.709 11.0391 11.04 13.7081 11.04 16.9993C11.04 20.2905 13.709 22.9595 17.0002 22.9595C20.2914 22.9595 22.9604 20.2905 22.9604 16.9993C22.9604 13.7081 20.2914 11.0391 17.0002 11.0391ZM17.0002 20.8685C14.865 20.8685 13.131 19.1379 13.131 16.9993C13.131 14.8607 14.865 13.1301 17.0002 13.1301C19.1354 13.1301 20.8694 14.8607 20.8694 16.9993C20.8694 19.1379 19.1354 20.8685 17.0002 20.8685Z"
        fill="white"
      />
      <path
        d="M23.1948 12.1991C23.9647 12.1991 24.5888 11.575 24.5888 10.8051C24.5888 10.0352 23.9647 9.41113 23.1948 9.41113C22.4249 9.41113 21.8008 10.0352 21.8008 10.8051C21.8008 11.575 22.4249 12.1991 23.1948 12.1991Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_526_34503"
          x1="4.97918"
          y1="29.0208"
          x2="29.0208"
          y2="4.97918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD521" />
          <stop offset="0.0551048" stopColor="#FFD020" />
          <stop offset="0.1241" stopColor="#FEC01E" />
          <stop offset="0.2004" stopColor="#FCA71B" />
          <stop offset="0.2821" stopColor="#FA8316" />
          <stop offset="0.3681" stopColor="#F85510" />
          <stop offset="0.4563" stopColor="#F51E09" />
          <stop offset="0.5" stopColor="#F30005" />
          <stop offset="0.5035" stopColor="#F20007" />
          <stop offset="0.5966" stopColor="#E1003B" />
          <stop offset="0.6879" stopColor="#D30067" />
          <stop offset="0.7757" stopColor="#C70088" />
          <stop offset="0.8589" stopColor="#BF00A0" />
          <stop offset="0.9357" stopColor="#BB00AF" />
          <stop offset="1" stopColor="#B900B4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default InstaGram;
